import React from 'react';

import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { SelectOption } from '@shared/ui/Select/model/types';

import cls from '@shared/ui/Select/Select.module.css';

export const OptionList = ({
    options,
    highlightedIndex,
    selectedValue,
    onSelect,
    optionClassName,
    maxHeight,
}: {
    options: SelectOption[];
    highlightedIndex: number | null;
    selectedValue: string | number | undefined;
    onSelect: (option: SelectOption) => void;
    optionClassName?: string;
    maxHeight?: number;
}) => {
    const { t } = useTranslation();
    return (
        <ul className={cls.dropdownList} role="listbox" style={{ maxHeight }}>
            {options?.length > 0 ? (
                options.map((option, idx) => (
                    <li
                        key={option.value}
                        className={classNames(
                            cls.optionItem,
                            {
                                [cls.highlighted]: idx === highlightedIndex && option.value != null,
                                [cls.notPicked]: option.value === null,
                            },
                            optionClassName,
                            option.classes && cls.optionItem
                        )}
                        onClick={() => {
                            if (option.callback) {
                                option.callback();
                            } else {
                                onSelect(option);
                            }
                        }}
                        role="option"
                        aria-selected={selectedValue === option.value}
                    >
                        <div
                            // title={option.label}
                            className={classNames(cls.optionItemText, [option.classes])}
                        >
                            {option.icon && option.icon}
                            {option.iconUrl && <img src={option.iconUrl} alt={option.label} />}
                            {option.label}
                        </div>
                    </li>
                ))
            ) : (
                <li className={cls.noOptions}>{t('Select.return.setResultOptions.notFind')}</li>
            )}
        </ul>
    );
};
